// removed by extract-text-webpack-plugin
module.exports = {"container":"_2KEFn9xHABVFUpYfnE5GQL","grid":"_10pegC8Nsf1PA_rWidnxxy","image":"_2IEIsTINZdKSsKj-JLtlP","headline":"_3_O_nF4zdU2Pd_VJpIgWro","copyContainer":"_2wIpXEYtSy61bcodsJVOuC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentSection/styles.css
// module id = 321
// module chunks = 0